var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 27.5H8.75C8.2375 27.5 7.8125 27.075 7.8125 26.5625C7.8125 26.05 8.2375 25.625 8.75 25.625H21.25C21.7625 25.625 22.1875 26.05 22.1875 26.5625C22.1875 27.075 21.7625 27.5 21.25 27.5Z",
    fill: "#F59400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4373 6.90005L20.4373 10.475C19.7748 10.95 18.8248 10.6625 18.5373 9.90005L16.1748 3.60005C15.7748 2.51255 14.2373 2.51255 13.8373 3.60005L11.4623 9.88755C11.1748 10.6625 10.2373 10.95 9.57479 10.4625L4.57479 6.88755C3.57479 6.18755 2.24979 7.17505 2.66229 8.33755L7.86229 22.9C8.03729 23.4 8.51229 23.725 9.03729 23.725H20.9498C21.4748 23.725 21.9498 23.3875 22.1248 22.9L27.3248 8.33755C27.7498 7.17505 26.4248 6.18755 25.4373 6.90005ZM18.1248 18.4375H11.8748C11.3623 18.4375 10.9373 18.0125 10.9373 17.5C10.9373 16.9875 11.3623 16.5625 11.8748 16.5625H18.1248C18.6373 16.5625 19.0623 16.9875 19.0623 17.5C19.0623 18.0125 18.6373 18.4375 18.1248 18.4375Z",
    fill: "#F59400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.872161ab857c35baef1cfd5cadaf76f6.svg";
export { ForwardRef as ReactComponent };